import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SapRelationSapAccountOldAccountService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SapRelationSapAccountOldAccountCreateDto,
  SapRelationSapAccountOldAccountDto,
  SapRelationSapAccountOldAccountExcelDownloadDto,
  SapRelationSapAccountOldAccountUpdateDto,
} from '../proxy/controlling/dtos/sap-relation-sap-account-old-account';
import { SAPRELATIONSAPACCOUNTOLDACCOUNT_CONFIG, SAPRELATIONSAPACCOUNTOLDACCOUNT_FIELDS } from './sap-relation-sap-account-old-account.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sap-relation-sap-account-old-account',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SapRelationSapAccountOldAccountService, ConfirmationService],
  templateUrl: './sap-relation-sap-account-old-account.html',
  styleUrl: './sap-relation-sap-account-old-account.scss',
})
export class SapRelationSapAccountOldAccount extends BaseHierarchicalCrudComponent<
  SapRelationSapAccountOldAccountDto,
  SapRelationSapAccountOldAccountCreateDto,
  SapRelationSapAccountOldAccountUpdateDto,
  SapRelationSapAccountOldAccountExcelDownloadDto
> {
  service = inject(SapRelationSapAccountOldAccountService);
  config = SAPRELATIONSAPACCOUNTOLDACCOUNT_CONFIG;
  fields = SAPRELATIONSAPACCOUNTOLDACCOUNT_FIELDS;

  protected prepareUpdateDto(data: any, selected: SapRelationSapAccountOldAccountDto): SapRelationSapAccountOldAccountUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SapRelationSapAccountOldAccount';
  }
}
